import dayjs from 'dayjs'

export const YEAR_FORMAT = 'YYYY'

export const formatSmallDuration = (secondsNum: number) => {
  const minutes = Math.floor(secondsNum / 60)
  const seconds = secondsNum - minutes * 60

  const minutesStr = minutes < 10 ? '0' + minutes : minutes
  const secondsStr = seconds < 10 ? '0' + seconds : seconds

  return `${minutesStr}:${secondsStr}`
}

export const isFeature = (date: Date | string, inputFormat?: string) => {
  return dayjs(date, inputFormat) > dayjs()
}

export const formatDateToDayjs = (date: string | string[]) =>
  Array.isArray(date) ? dayjs(date[0]) : dayjs(date)

export const formatToIsoString = (date: dayjs.ConfigType) =>
  dayjs(date).toISOString()

export const getAPIDateFormat = (date: string) =>
  date.split('.').reverse().join('-')

export const isEditorContentEmpty = (html: string): boolean => {
  return (
    !html ||
    html.replace(/<(\/)?(p|div|br|strong|em|u|b|i|span)[^>]*>/g, '').trim() ===
      ''
  )
}
